import React from 'react';
import type { DownloadGuideSectionProps } from '../../types/travel-payment';

// Document Icon Component
const DocumentIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M8,12V14H16V12H8Z M8,16V18H13V16H8Z"/>
  </svg>
);

// Download Icon Component
const DownloadIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"/>
  </svg>
);

const DownloadGuideSection: React.FC<DownloadGuideSectionProps> = ({ 
  onDownload, 
  onBackToLogin, 
  className = '' 
}) => {
  const handleDownload = () => {
    onDownload();
  };

  const handleBackToLogin = () => {
    onBackToLogin();
  };

  return (
    <div className={`integrated-section download-guide-section ${className}`}>
      <h2 className="integrated-section-title">Download User Guide</h2>
      
      <div className="download-guide-icon-container">
        <DocumentIcon className="download-guide-icon" />
      </div>
      
      <p className="download-guide-description">
        Get comprehensive instructions on how to use the Pacific Cross Travel Portal
      </p>
      
      <button 
        type="button" 
        className="integrated-section-button download-guide-button button-gradient"
        onClick={handleDownload}
      >
        <DownloadIcon className="download-icon" />
        Download PDF Guide
      </button>
      
      <div 
        className="integrated-back-link"
        onClick={handleBackToLogin}
      >
        ← Back to Login
      </div>
    </div>
  );
};

export default DownloadGuideSection;